import script from "./SubmitView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitView.vue?vue&type=script&setup=true&lang=js"

import "./SubmitView.vue?vue&type=style&index=0&id=5ce82043&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce82043"]])

export default __exports__